import { useState } from 'react';
import { ChangePINProvider } from '../../contexts/changePIN';

/**
 * 
 * @param {{
 *    component: React.JSX.Element;
 * }} props 
 * @returns {React.JSX.Element}
 */
const ChangePINController = (props) => {
  const { component: Component } = props;

  return (
    <ChangePINProvider
      value={{
      }}
    >
      <Component {...props} />
    </ChangePINProvider>
  );
};

/**
 * @param {React.JSX.Element} Component 
 * @returns {(props: object) => TasksController}
 */
export const ChangePINControllerHOC = (Component) => (props) => (
  <ChangePINController component={Component} {...props} />
);

export default ChangePINControllerHOC;
